import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { NavItem } from 'react-bootstrap';
import PropTypes from 'prop-types';

class ForecastNav extends Component {
  render() {
    const availablePrograms = [
      {
        slug: 'current',
        label: 'Current',
      },
      {
        slug: 'history',
        label: 'History',
      },
    ];
    return (
      <ul className="nav nav-tabs">
        {availablePrograms.map(supportProgram => (
          <LinkContainer key={supportProgram.slug} to={`/forecast/${supportProgram.slug}`}>
            <NavItem>{supportProgram.label}</NavItem>
          </LinkContainer>
          ))}
      </ul>
    );
  }
}

ForecastNav.propTypes = {};

ForecastNav.contextTypes = {
  router: PropTypes.object,
};

export default ForecastNav;
